import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Button, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { useSelector } from "react-redux";
import { GrillaAportes } from "./GrillaAportes";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  }
}));

export const ModalAportesPreafiliado = (props) => {
  const classes = useStyles();
  const { items } = useSelector((state) => state.aportesAfiliado);

  return (
    <div className={classes.root}>
      <Dialog
        maxWidth="lg"
        fullWidth={true}
        className={classes.root}
        open={props.open}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="tituloModal" onClose={props.handleClose}>
          Aportes
        </DialogTitle>
        <DialogContent >
            {
                items.length === 0 
                ?
                <Typography align="center">No tiene aportes para mostrar.</Typography>
                :
                <GrillaAportes />
            }
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={props.handleClose} variant="contained" color="secondary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
